// extracted by mini-css-extract-plugin
export default {"Container":"Title_Container__nEqaI","Title":"Title_Title__n1ME-"};